// JS feature detection for CSS.
// doing this inside main.js to also detect load failure

document.documentElement.className = document.documentElement.className.replace("no-js","js")
